module.exports = __webpack_public_path__ + "static/media/flutter.450062ba.svg";